export function toggleMenu() {
  const checkbox = document.querySelector("#checkboxMenu");
  const menu = document.querySelector(".menu-items");
  const body = document.querySelector("body")

  const menuLinks = document.querySelectorAll(".menu-items a");
  const links = Array.from(menuLinks);

  checkbox&&checkbox.addEventListener("change", function () {
    if (this.checked) {
      menu.classList.add("open");
      body.classList.add("no-scroll")
      links.map((link) => {
        link.addEventListener("click", function () {
          checkbox.checked = false;
          menu.classList.remove("open");
          body.classList.remove("no-scroll")
        });
      });
    } else {
      menu.classList.remove("open");
      body.classList.remove("no-scroll")
    }
  });
}
